import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TicketScanColorComponent extends Component {
  static readonly TYPE_ID = '6c1c269189d243ba8c2b13609b8814d3';

  private constructor(
    public readonly color: number,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return TicketScanColorComponent.TYPE_ID;
  }

  static create(args: { color: number }): TicketScanColorComponent {
    return new TicketScanColorComponent(args.color);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketScanColorComponent {
    return this.create({
      color: MapUtils.getNumber(map, 'color'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      color: this.color,
    };
  }

  clone(): this {
    return TicketScanColorComponent.create({
      color: this.color,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.color === this.color;
  }
}

export class TicketScanColorComponentBuilder extends DataModelBuilder<TicketScanColorComponent> {
  build(context: SerializationContext, map: SerializedData): TicketScanColorComponent {
    return TicketScanColorComponent.fromMap(context, map);
  }
}
